import axios from '@/utils/axios';
import {
  ProviderCityPrice,
  ProviderCityPriceFilters,
  ProviderCityPricePayload,
} from '../types';

const cleanFilters = (filters: ProviderCityPriceFilters = {}) =>
  Object.entries(filters).reduce<Record<string, string | number | boolean>>(
    (params, [key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params[key] = value;
      }

      return params;
    },
    {}
  );

const normalizeProviderCityPrice = (
  price: ProviderCityPrice
): ProviderCityPrice => ({
  ...price,
  cities: price.cities ?? price.city,
  service_variant: {
    ...price.service_variant,
    name: price.service_variant.variant_name ?? price.service_variant.name,
  },
});

export async function getProviderCityPrices(
  filters?: ProviderCityPriceFilters
): Promise<ProviderCityPrice[]> {
  const {
    data: { data },
  } = await axios.get('/provider-city-prices', {
    params: cleanFilters(filters),
  });

  return data.map(normalizeProviderCityPrice);
}

export async function getProviderCityPrice(
  id: string
): Promise<ProviderCityPrice> {
  const {
    data: { data },
  } = await axios.get(`/provider-city-prices/${id}`);

  return normalizeProviderCityPrice(data);
}

export async function createProviderCityPrice(
  payload: ProviderCityPricePayload
) {
  const { data } = await axios.post('/provider-city-prices', payload);
  return data;
}

export async function updateProviderCityPrice(
  id: string,
  payload: ProviderCityPricePayload
) {
  const { data } = await axios.put(`/provider-city-prices/${id}`, payload);
  return data;
}

export async function deleteProviderCityPrice(id: string) {
  await axios.delete(`/provider-city-prices/${id}`);
}
